/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-03-27 03:47:36
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Button } from '@shopify/polaris';
import { PlusMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import TagDetails from './tag-details';

import { MAX_TAG_LEVEL } from 'src/constants/filter-tree';

type Props = {
  value: any,
  onClick: () => void
};

type ComposedProps = Props & WithI18nProps;

class TreeNodeTagsButton extends Component<ComposedProps> {
  render() {
    const { i18n, value, onClick } = this.props;
    return (
      <Button outline onClick={onClick} icon={PlusMinor}>
        {value
          ? i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_GeneralTab_MultiLevelTag_TreeNodeTags_Content_ToValue',
              {
                t: (
                  <strong>
                    {i18n.translate(
                      'AdminHTML.FilterTree.Item.optionModal_GeneralTab_MultiLevelTag_TreeNodeTags_Content_ToValue_t',
                      { nt: value }
                    )}
                  </strong>
                )
              }
            )
          : i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_GeneralTab_MultiLevelTag_TreeNodeTags_Content'
            )}
      </Button>
    );
  }
}

const TreeNodeTagsButtonWithI18n = withI18n()(TreeNodeTagsButton);
// DONE
class TreeNodeTags extends Component<{}, State> {
  constructList = ({
    tags,
    formValues,
    tagOptions,
    droppableId,
    type,
    mainIndex,
    level,
    routePath,
    className,
    source,
    addNewTag,
    removeTag,
    showHideSubTags,
    updateManualValues
  }) => {
    return (
      <div className="List_MultiLevelTags">
        <Droppable droppableId={droppableId} type={type}>
          {(provided, snapshot) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {tags.map((item, key) => {
                const path = routePath ? `${routePath}/${key}` : `${key}`;
                // Get tag at current path
                const tag = this.getValue(path);
                // Get tag value
                const value = _.get(tag, 'tag.value', '');
                return (
                  // Enable drag for per option row
                  <Draggable
                    draggableId={`${droppableId}_${key}`}
                    key={`${droppableId}_${key}`}
                    index={key}>
                    {(provided, snapshot) => {
                      return (
                        <div
                          className={`BC-Draggable ${snapshot.isDragging ? 'dragging' : ''}`}
                          ref={provided.innerRef}
                          {...provided.draggableProps}>
                          <TagDetails
                            provided={provided}
                            snapshot={snapshot}
                            item={item}
                            formValues={formValues}
                            key={mainIndex}
                            routePath={path}
                            total={tags.length || 0}
                            tagOptions={tagOptions}
                            source={source}
                            removeTag={removeTag}
                            showHideSubTags={showHideSubTags}
                            updateManualValues={updateManualValues}
                          />

                          {/* Render sub tags*/}
                          {tag.subTags &&
                          tag.subTags.length > 0 &&
                          (tag.expanded || !_.has(tag, 'expanded')) ? (
                            <TreeNodeTags
                              droppableId={`${droppableId}_${key}`}
                              type={`${droppableId}_${key}`}
                              tags={tag.subTags}
                              formValues={formValues}
                              tagOptions={tagOptions}
                              mainIndex={key}
                              level={level + 1}
                              routePath={path}
                              className={'subTagBox1'}
                              source={source}
                              addNewTag={addNewTag}
                              removeTag={removeTag}
                              showHideSubTags={showHideSubTags}
                              updateManualValues={updateManualValues}
                            />
                          ) : (
                            ''
                          )}

                          {/* Sub tag level 2*/}
                          {level < MAX_TAG_LEVEL ? (
                            <div className={`buttonAdd buttonAddSubTag1`}>
                              {' '}
                              <TreeNodeTagsButtonWithI18n
                                value={value}
                                onClick={() => addNewTag(path)}
                              />
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      );
                    }}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    );
  };

  render() {
    const { className } = this.props;
    return <div className={className}>{this.constructList(this.props)}</div>;
  }

  getValue = path => {
    const { formValues, source = '' } = this.props;

    const parsed = path.split('/');
    let accessPath = '';
    parsed.forEach((key, index) => {
      if (!key) return;
      if (index === 0) {
        accessPath = `[${key}]`;
      } else {
        accessPath =
          source === 'multi-level-collections'
            ? `${accessPath}.tags[${key}]`
            : `${accessPath}.subTags[${key}]`;
      }
    });

    // Get tag
    return _.get(formValues, accessPath, {});
  };
}

export default TreeNodeTags;
